import { CapoPlugin } from "/home/runner/work/ss-bonsai-catalog-frontend/ss-bonsai-catalog-frontend/app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];